<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Uploading Custom KPI</h1>
      <p>
        By clicking <b><i class="fas fa-plus-circle"/> Upload Custom KPI</b> button on the sidebar, a dialog will appear
        which has two fields: file upload, and name for the set of KPIs. When you <b>upload a file</b> you will be informed
        about the <b>validity of the headers</b> of the CSV file.
      </p>

      <div class="image-container">
        <img src="@/images/manual/comparison-kpis-first-graph.png" alt="clone project button" />
        <div class="img-caption">
          Figure 1. Invalid KPIs Uploaded
        </div>
      </div>

      <p>
        If the CSV file contains <b>no errors</b> the user should see no informative messages at all.
      </p>

      <div class="image-container">
        <img src="@/images/manual/comparison-kpis-first-graph.png" alt="clone project button" />
        <div class="img-caption">
          Figure 2. Valid KPIs Uploaded
        </div>
      </div>

      <p>
        Users are able to download a template with the valid headers of a CSV file containing KPIs.
        The following list shows the <b>valid headers</b> contained in such files.
      </p>
      <div class="ml-5">
        <ul>
          <li>KPI (text)</li>
          <li>Aggregation Level CITY</li>
          <li>Functional Unit (text)</li>
          <li>Assigned Dimension</li>
          <li>Aggregation Level Building</li>
          <li>Dimension Weight Building</li>
          <li>Value (Building)</li>
          <li>Sectors Weight Building</li>
          <li>Aggregation Level PEB</li>
          <li>Dimension Weight PEB</li>
          <li>Value (PEB)</li>
          <li>Sectors Weight PEB</li>
          <li>Aggregation Level PED</li>
          <li>Dimension Weight PED</li>
          <li>Value (PED)</li>
          <li>Sectors Weight PED</li>
          <li>Aggregation Level CITY</li>
          <li>Dimension Weight CITY</li>
          <li>Value CITY</li>
          <li>Sectors Weight CITY</li>
          <li>Assigned Sectors (Climate_Change_&Mitigation/Resource_Efficiency/Quality_of_Life_&Prosperity/Smart_&Reliable_Infrastructure)</li>
          <li>Failed (double number)</li>
          <li>Underachieved (double number)</li>
          <li>Achieved (double number)</li>
          <li>Overachieved (double number)</li>
        </ul>
      </div>
      <p class="mt-5">
        Optionally for the KPIs, <b>there's an additional value</b> called "Benchmark value (double number)". With this
        header present, the <b>margins of the KPI list will be modified.</b> Specifically, each margin will be done like
        this:
      </p>
      <pre>
      (margin / benchmark value) * 100
      </pre>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>